define('views/blocks/ReorderOrderSingleView',['underscore','jquery','backbone','app','hooks','SubView','UrlFactory',
        'TagCommander',
        'template!blocks/reorder-order-single',
        'template!blocks/product-block-small',
        'InternalLinkView'
    ],
    function (_,$,Backbone,app,hooks,SubView,UrlFactory,
              TagCommander,
              reorderOrderSingleTemplate,
              productBlockSmallTemplate,
              InternalLinkView) {

    return Backbone.View.extend(SubView).extend({
        events:{
            'click .btn-reorder':'reorder',
            'click a': 'trackClick',
            'click .reorder-order-single__img, .reorder-order-single__infos': 'openDetails',
            'click .btn-close': 'closeDetails',
        },
        initialize:function(options) {
            var view = this, order = options.order;
            view.order = order
            view.render();
            if(!order.getMaxPriceProduct()){
                view.listenToOnce(order,'sync',view.render);
                view.prefetchDetail();
            }

            view.listenTo(app.getCart(),'productsChange', view.closeDetails);
        },

        render:function() {
            var view = this;
            view.$el.html(reorderOrderSingleTemplate({order:view.order}));
        },

        reorder:function(e){
            var view = this,
                order = view.order;

            e.preventDefault()
            e.stopPropagation()
            if(order){
                var cart = app.getCart(),
                    id_cart = order.get('id_cart');
                if(id_cart){
                    cart.reorder(order);
                }else{
                    app.alert();
                }
            }
        },

        prefetchDetail:function() {
            this.order.fetch();
        },

        openDetails:function(e) {
            var view = this,
                order = view.order,
                html = '';

            if (!view.$('.product-block-small').length) {
                order.once('sync', onSync);
                order.fetch();
            }

            view.$('.reorder-order-single').addClass('active');

            function onSync() {
                var products = order.getProducts(),
                    wrapper = view.$('.reorder-order-single__products');

                products.each(function(orderProduct) {
                    var product = orderProduct.getProduct()
                    html += productBlockSmallTemplate({product: product, quantity: orderProduct.get('quantity')})
                })
                view.$('.reorder-order-single__products').html(html);

                view.activeSlide = 0
                view.totalSlides = Math.floor((products.length - 1) / 3)

                if (products.length > 3) {
                    view.$('.reorder-order-single__buttons').addClass('active');
                }

                setTimeout(function() {
                    view.resize();
                    view.initSlider()
                })

                if (app.isMobile()) {
                    wrapper.on('touchstart',function(event){
                        view.touchstartX = event.originalEvent.changedTouches[0].screenX;
                    });
                    wrapper.on('touchend',function(event){
                        view.touchendX = event.originalEvent.changedTouches[0].screenX;
                        view.handleGesture();
                    });
                }
            }

            view.listenTo(app,'updateDocumentDimensions',view.resize);
        },

        closeDetails: function() {
            var view = this;
            view.$('.reorder-order-single').removeClass('active');
        },

        resize:function() {
            var view = this,
            parentWidth = view.$('.reorder-order-single__details').innerWidth();
            view.$('.reorder-order-single__products .product-block-small').width(parentWidth / 3);
        },

        trackClick:function(e) {
            var currentTarget = e.currentTarget,
                productId = currentTarget.getAttribute('data-id_product'),
                product = app.getProduct(productId);

            e.preventDefault();
            app.go('product',{product:product});
        },

        initSlider:function() {
            var view = this,
                buttons = view.$('.reorder-order-single__button');

            buttons.click(view.triggerClick.bind(view));
        },

        handleGesture:function(){
            var view = this,
                tolerance = 25;

            if (view.touchendX + tolerance < view.touchstartX) {
                this.next();
                view.changeSlide();
            }
            if (view.touchendX - tolerance > view.touchstartX) {
                this.previous();
                view.changeSlide();
            }
        },

        triggerClick:function(e) {
            var view = this,
                currentTarget = $(e.currentTarget);

            if (currentTarget.hasClass('previous')) {
                view.previous()
            } else if (currentTarget.hasClass('next')) {
                view.next()
            }

            view.changeSlide();
        },

        changeSlide: function() {
            var view = this,
                wrapper = view.$('.reorder-order-single__products'),
                size = view.$('.reorder-order-single__details').innerWidth();

            wrapper.css('transform', 'translate(-'+ size * view.activeSlide +'px)');
        },

        next: function() {
            var view = this;
            if (view.activeSlide < view.totalSlides) {
                view.activeSlide ++;
            } else {
                view.activeSlide = 0;
            }
        },

        previous: function() {
            var view = this;
            if (view.activeSlide > 0) {
                view.activeSlide --;
            } else {
                view.activeSlide = view.totalSlides;
            }
        }
    });
})
;
